import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = () => ({
    'default': [
        {
            id: 'periodo',
            label: 'Tempo de Resgate (DC)',
        },
        {
            id: 'valor',
            label: 'Valor Líquido',
            align: AlignTypes.right,
        },
        {
            id: 'percent',
            label: '%',
            align: AlignTypes.right,
        },
    ],
});
